function formatDisplay(value) {
  if (value === null || value === undefined || value === '') {
    return '—';
  }
  return String(value);
}

function DeliveryChallanScheduleBanner({
  customer,
  site,
  soNo,
  scheduleQty,
  balanceQty,
  cumSlNo,
  cumQty,
  visible = true,
}) {
  if (!visible) {
    return null;
  }

  const columns = [
    { label: 'Customer', value: customer },
    { label: 'Site', value: site },
    { label: 'SO No.', value: soNo },
    { label: 'Schedule Qty', value: scheduleQty },
    { label: 'Balance Qty', value: balanceQty },
    { label: 'Cum. Sl. No.', value: cumSlNo },
    { label: 'Cum. Qty.', value: cumQty },
  ];

  return (
    <div className="dc-ws-details-header">
      <div className="dc-ws-details-title">Schedule Details</div>
      <div className="dc-ws-details-table-wrap">
        <table className="dc-ws-details-table">
          <thead>
            <tr>
              {columns.map((column) => (
                <th key={column.label}>{column.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              {columns.map((column) => (
                <td key={column.label}>{formatDisplay(column.value)}</td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default DeliveryChallanScheduleBanner;
